var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRxjs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_649_382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.7661 31.1627C1.78172 28.0967 1.49897 24.8593 2.06597 21.5286C2.31197 20.1471 2.69147 18.8215 3.10735 17.4782C3.10735 17.4782 5.71922 8.90458 14.558 4.98621C14.558 4.98621 17.6048 3.37745 22.1855 3.26496C22.1855 3.26496 21.5615 2.65858 21.1632 2.39345C19.0055 0.954955 15.7887 0.481705 13.8391 2.50783C13.2515 3.1127 12.7591 3.77608 12.2116 4.38133C11.5861 5.06233 10.8286 5.63083 9.9586 5.95146C9.2011 6.2357 8.4436 6.1787 7.66885 6.31183C6.87385 6.44383 6.05897 6.72808 5.41622 7.23921C4.71572 7.8077 4.43185 8.56333 4.35685 9.43483C4.28072 10.1162 4.29985 10.8163 4.2616 11.4973C4.16672 13.5043 3.5236 14.0713 2.0851 15.1888C1.47985 15.643 0.968724 16.2478 0.589224 16.8925C-0.545901 18.898 1.27172 20.9792 1.36547 23.0053C1.38497 23.4216 1.34672 23.8375 1.19597 24.2357C1.04335 24.6707 0.741849 24.955 0.495474 25.3138C0.154224 25.7875 -0.0726509 26.3556 0.0229741 26.9413C0.116724 27.529 0.419724 28.078 0.703974 28.5895C1.25335 29.4977 1.93435 30.3107 2.65397 31.087C2.69147 31.087 2.7286 31.1248 2.76647 31.1631",
    fill: "#E32186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8805 38.4287C43.2338 36.5361 45.0886 33.2623 45.0886 33.2623C49.1581 27.7164 47.7766 21.8687 47.7766 21.8687C45.1838 27.5083 42.8165 29.0612 42.8165 29.0612C49.196 19.3506 42.8547 13.4841 42.8547 13.4841C45.4475 19.0108 42.0035 25.7477 42.0035 25.7477C39.1073 31.8429 35 34.0198 35 34.0198C39.5806 34.8711 42.95 31.7859 42.95 31.7859C36.3811 38.8832 29.2651 38.5434 29.2651 38.5434C32.2565 41.8937 36.7418 41.6094 36.7418 41.6094C30.875 42.9906 25.3673 41.0409 20.8437 37.2744C19.9867 36.5723 19.1774 35.8139 18.4212 35.0042C18.4212 35.0042 17.7398 34.2849 17.6063 34.0959L17.5876 34.0772C17.4938 37.5778 21.1456 40.8328 21.1456 40.8328C16.565 38.9406 14.4646 34.8328 14.4646 34.8328C14.4646 34.8328 11.3795 29.5716 13.6133 23.5727C15.8457 17.5727 22.6032 16.2849 22.6032 16.2849C28.1873 18.9924 32.9187 19.8433 32.9187 19.8433C42.893 21.5087 42.326 16.6266 42.326 16.6266C42.4197 12.4239 36.08 7.9577 36.08 7.9577C24.7801 -0.427304 14.5598 4.98545 14.5598 4.98545C5.72109 8.90382 3.10922 17.4774 3.10922 17.4774C2.69297 18.8207 2.31422 20.1463 2.06784 21.5274C1.10259 27.1498 2.55984 32.4673 5.72109 37.2002C10.6415 44.5434 18.6293 47.0792 18.6293 47.0792C30.458 51.0913 38.5396 45.1866 38.5396 45.1866C45.9781 40.0753 47.4736 34.1709 47.4736 34.1709C41.4736 38.8659 38.8808 38.4291 38.8808 38.4291L38.8805 38.4287ZM29.6446 10.8148C29.779 10.8143 29.9121 10.8404 30.0363 10.8917C30.1605 10.9429 30.2733 11.0182 30.3683 11.1133C30.4632 11.2084 30.5384 11.3213 30.5894 11.4456C30.6405 11.5699 30.6664 11.7031 30.6657 11.8374C30.6662 11.9717 30.6401 12.1047 30.589 12.2287C30.5378 12.3528 30.4626 12.4656 30.3677 12.5605C30.2728 12.6554 30.16 12.7305 30.0359 12.7816C29.9118 12.8327 29.7788 12.8587 29.6446 12.8582C29.5103 12.8589 29.3771 12.833 29.2529 12.7819C29.1286 12.7309 29.0157 12.6558 28.9206 12.5609C28.8255 12.466 28.7502 12.3532 28.6989 12.229C28.6477 12.1049 28.6215 11.9718 28.622 11.8374C28.6213 11.703 28.6473 11.5697 28.6985 11.4453C28.7497 11.321 28.825 11.208 28.92 11.1129C29.0151 11.0178 29.1281 10.9425 29.2525 10.8913C29.3769 10.8402 29.5101 10.8142 29.6446 10.8148Z",
    fill: "url(#paint0_linear_649_382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.304 16.6079C42.3977 12.4053 36.058 7.93907 36.058 7.93907C24.7581 -0.426806 14.5378 4.98594 14.5378 4.98594C5.69908 8.90432 3.08721 17.4779 3.08721 17.4779C2.57608 18.9356 2.12196 21.1694 2.12196 21.1694C1.57258 23.9703 1.81858 26.5631 1.81858 26.5631C2.04583 29.0429 2.59483 30.7087 2.59483 30.7087C3.16333 32.4869 3.42733 33.0363 3.42733 33.0363C3.40933 32.9789 3.31446 32.5631 3.31446 32.5631C3.31446 32.5631 2.51871 28.7399 3.25708 25.0676C3.25708 25.0676 3.90021 21.2444 6.51358 18.2928C6.51358 18.2928 10.753 12.2546 18.6456 14.6204C18.6456 14.6204 20.3492 15.2268 20.935 15.5287C21.5226 15.8129 22.5437 16.2479 22.5437 16.2479C28.1275 18.9551 32.8588 19.8059 32.8588 19.8059C42.8713 21.4904 42.3043 16.6083 42.3043 16.6083L42.304 16.6079ZM29.6417 12.8786C29.5073 12.8793 29.3742 12.8533 29.2499 12.8023C29.1256 12.7512 29.0127 12.6761 28.9176 12.5811C28.8225 12.4862 28.7472 12.3734 28.6959 12.2491C28.6447 12.1249 28.6186 11.9918 28.6191 11.8574C28.6184 11.723 28.6444 11.5897 28.6956 11.4653C28.7468 11.341 28.8221 11.228 28.9172 11.1329C29.0122 11.0378 29.1252 10.9625 29.2496 10.9113C29.374 10.8602 29.5072 10.8342 29.6417 10.8348C29.7761 10.8343 29.9092 10.8604 30.0334 10.9117C30.1576 10.9629 30.2704 11.0382 30.3654 11.1333C30.4603 11.2284 30.5355 11.3413 30.5865 11.4656C30.6376 11.5899 30.6635 11.7231 30.6628 11.8574C30.6634 11.9917 30.6373 12.1247 30.5862 12.2489C30.5351 12.373 30.4599 12.4858 30.365 12.5807C30.27 12.6756 30.1573 12.7508 30.0331 12.802C29.909 12.8531 29.776 12.8791 29.6417 12.8786Z",
    fill: "url(#paint1_radial_649_382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1696 8.99953L16.7155 6.99253C16.6772 6.99253 16.4886 6.89728 16.147 6.99253C16.147 6.99253 12.3426 7.95815 13.0052 10.0394C13.0052 10.0394 13.4035 11.3463 14.4816 12.6134L21.5789 12.2733L23.1696 8.99953Z",
    fill: "url(#paint2_linear_649_382)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_649_382",
    x1: 7.28915,
    y1: 44.8656,
    x2: 30.8408,
    y2: 19.8101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF1C84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#DE1C85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#932C86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C2F87"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_649_382",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.2124 13.1633) rotate(0.136224) scale(23.0115 19.2419)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF1C84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.139,
    stopColor: "#DE1E85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#D62085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.434,
    stopColor: "#C82286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#B72786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#9C2A86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#7C2E87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C2F87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_649_382",
    x1: 12.9133,
    y1: 9.78186,
    x2: 23.1638,
    y2: 9.78186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF1C84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238,
    stopColor: "#D91E85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658,
    stopColor: "#C72085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#B42184"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_649_382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.8125)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRxjs);
export default __webpack_public_path__ + "static/media/rxjs.49caac852b0f63375cd5bcb52d94fc8c.svg";
export { ForwardRef as ReactComponent };